import dynamic from 'next/dynamic'

export const BentoSquareCounter = dynamic(
    () => import('./bento-square-counter'),
)
